import React, {useEffect, useState} from "react";
import "./referral.style.scss";
import {Button, Card, Dropdown, Menu, Modal, Spin} from "antd";
import {get, post, responseValidator, SITEURL} from "../../../api";
import {toast} from "react-toastify";
import Loading from "../../../loading/loading.index";
import DownOutlined from "@ant-design/icons/lib/icons/DownOutlined";

export default function Referral() {
    const [user, setUser] = useState(null)
    const [isModal, setIsModal] = useState(false);
 const [confirmLoading, setConfirmLoading] = useState(false);
    const [allCards, setAllCards] = useState(undefined);
    const [selectedCard, setSelectedCard] = useState(null);

    function getBanks() {
        return new Promise(resolve => {
            get("/BankAccount/Mine").then(res => {
                resolve(true);
                if (responseValidator(res.status)) {
                    setSelectedCard(res.data.data[0]);
                    setAllCards(res.data.data);
                }
            });
        });
    }
      function withdrawHandler() {
          setConfirmLoading(true)
        post("/ReferralReward/Withdraw", { bankAccount: selectedCard.id }).then(
            res => {
                setIsModal(false);
                setConfirmLoading(false)
                if (responseValidator(res.status)) {
                    toast.success(res.data.message);
                    getReferralReward()
                } else toast.error(res.data.message);
            }
        );

    }
function getReferralReward(){
    get('/ReferralReward/Info').then(res => {
        if (responseValidator(res.status)) {
            console.log(res)
            setUser(res.data.data);
        } else toast.error(res.data.message)
    })
}
    useEffect(() => {
        getReferralReward()
    }, [])
    useEffect(() => {
        if (isModal) {
            getBanks();
        }
    }, [isModal]);

    function shareHandler(e) {
      //  console.log(window.location);
        e.preventDefault();
        navigator.clipboard.writeText(
            user.referralCode
        );
        toast.success("کد معرف کپی شد");
    }

    function shareHandler2(e) {
      //  console.log(window.location);
        e.preventDefault();
        navigator.clipboard.writeText(
            user.fullLink
        );
        toast.success("لینک معرف کپی شد");
    }
    if (!user)
        return <Loading/>
    return (
        <div className="gx-main-content row referral-page">
             <Modal
                closable={false}
                className="verification-my-modal"
                footer={[
                    <Button
                        key="submit"
                        type="primary"
                        disabled={confirmLoading}
                        loading={confirmLoading}
                        onClick={withdrawHandler}
                    >
                        برداشت
                    </Button>,
                    <Button key="back" onClick={() => setIsModal(false)}>
                        انصراف
                    </Button>
                ]}
                onCancel={() => setIsModal(false)}
                visible={isModal}
            >
                  <div className="withdraw-modal-body">
                    <p>کارت خود را انتخاب کنید : </p>
                    {allCards ? (
                        allCards.length !== 0 ? (
                            <Dropdown
                                overlay={
                                    <Menu>
                                        {allCards.map(item => (
                                            <Menu.Item
                                                onClick={() =>
                                                    setSelectedCard(item)
                                                }
                                                key={item.id}
                                            >
                                                <div className="one-card-drop-down-selected ">
                                                    <img
                                                        src={
                                                            SITEURL + item.icon
                                                        }
                                                        alt="Bank"
                                                    />
                                                    <h4>{item.bankName}</h4>
                                                    <p>{item.cardNumber}</p>
                                                </div>
                                            </Menu.Item>
                                        ))}
                                    </Menu>
                                }
                                trigger={["click"]}
                            >
                                <div className="one-card-drop-down-selected">
                                    <img
                                        src={SITEURL + selectedCard.icon}
                                        alt="Bank"
                                    />
                                    <h4>{selectedCard.bankName}</h4>
                                    <p>{selectedCard.cardNumber}</p>
                                    <DownOutlined />
                                </div>
                            </Dropdown>
                        ) : (
                            <p>کارتی یافت نشد!</p>
                        )
                    ) : (
                        <Spin />
                    )}
                </div>
            </Modal>
            <Card title='کسب درآمد'>
                <p className='description'>با دعوت دوستان خود در تم ایکس برای خود درآمد زایی کنید . برای مشاهده نحوه کسب درآمد <a target='_blank' href='/page/affiliate/'>کلیک کنید</a></p>
               <hr/>
                <div className="user-info-div">
                    <p className="user-info">کد اختصاصی شما جهت معرفی دیگران :</p>
                    <h4>{user.referralCode}</h4>
                    <span/>
                    <Button onClick={shareHandler} type={"primary"}>
                        انتشار
                    </Button>
                </div>
                  <hr />
                 <div className="user-info-div">
                    <p className="user-info">لینک اختصاصی شما جهت دعوت دوستان :</p>
                    <h4>{user.fullLink}</h4>
                    <span/>
                    <Button onClick={shareHandler2} type={"primary"}>
                        انتشار
                    </Button>
                </div>
                <hr/>
                <div className="user-info-div">
                    <p className="user-info">تعداد کاربران دعوت شده توسط شما :</p>
                    <h4>{user.subsetsCount}</h4>
                </div>
                  <hr />
                <div className="user-info-div">
                    <p className="user-info">
                        درآمد کسب شده توسط شما :{" "}
                    </p>
                    <h4>{user.balance} تومان</h4>
                    <span/>
                    <Button
                        disabled={user.balance === 0}
                        onClick={() => setIsModal(true)}
                        type={"primary"}
                    >
                        برداشت
                    </Button>
                </div>
            </Card>
        </div>
    );
}
